import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as _ from "lodash";

import ImageUploader from "./ImageUploader";
import { ImageData, State } from "../../interfaces";
import { ActivityButton } from "./ActivityButton";
import {
  generateSequenceNumber,
  uploadAndCreateFlashCard,
  uploadFlashCardImageSuccess,
} from "../../store/actions";
import { SequenceEnum } from "../../enums";

type TProps = {
  lessonId: string;
};
const FlashCardImageUploader: React.FC<TProps> = ({ lessonId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //#region internal state
  const [images, setImages] = useState<ImageData[]>([]);
  const [nextSequenceNumber, setNextSequenceNumber] = useState<number>();
  //#endregion

  //#region redux
  const uploadState: any = useSelector(
    (state: any): any => state.flashCard.uploadAndCreateFlashCard
  );
  const {
    loading: getSequenceNumberLoading,
    success: getSequenceNumberSuccess,
    response: getSequenceNumberResponse,
  } = useSelector(
    (state: any): State<{ sequenceNumber: number }> =>
      state.appSettings.sequenceNumber
  );
  //#endregion

  //#region handlers
  const onUpload = () => {
    if (!nextSequenceNumber) {
      dispatch(
        generateSequenceNumber({
          type: SequenceEnum.FLASH_CARD,
          lessonId: lessonId,
        })
      );
    } else {
      const orderedImage = _.orderBy(images, "file.name", "asc");
      orderedImage
        .filter((image) => image.file)
        .forEach((image, index) => {
          console.log({
            localId: image.localId as number,
            file: image.file as File,
            lessonId: lessonId,
            sequenceNumber: nextSequenceNumber + index,
          });
          dispatch(
            uploadAndCreateFlashCard({
              localId: image.localId as number,
              file: image.file as File,
              lessonId: lessonId,
              sequenceNumber: nextSequenceNumber + index,
            })
          );
          setNextSequenceNumber(undefined);
        });
    }
  };

  //#endregion

  //#region effects
  useEffect(() => {
    if (!getSequenceNumberLoading && getSequenceNumberSuccess) {
      if (getSequenceNumberResponse) {
        const { sequenceNumber } = getSequenceNumberResponse;
        setNextSequenceNumber(sequenceNumber);
      }
    }
  }, [getSequenceNumberLoading, getSequenceNumberSuccess]);

  useEffect(() => {
    if (nextSequenceNumber) {
      onUpload();
    }
  }, [nextSequenceNumber]);

  //#endregion

  return (
    <>
      <ImageUploader
        multiple
        removable
        required
        onChangeImages={(_imgs) => setImages(_imgs)}
        uploadMediaState={uploadState}
      />
      {images.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: 20,
            paddingBottom: 20,
          }}
        >
          <ActivityButton
            title={t("saveFlashCards")}
            inProgressTitle="saving"
            color="success"
            className="btn btn-success btn-block"
            type="submit"
            inProgress={
              uploadState.some((s: any) => s.loading) ||
              getSequenceNumberLoading
            }
            disabled={
              uploadState.some((s: any) => s.loading) ||
              getSequenceNumberLoading
            }
            onClick={onUpload}
          ></ActivityButton>
        </div>
      )}
    </>
  );
};

export default FlashCardImageUploader;
